// UserInfoQuestionRolesTab.js
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Button } from "reactstrap";
import Select from "react-select";
import axiosInstance from "utils/axiosInstance";

const booleanOptions = [
  { value: true, label: "是" },
  { value: false, label: "否" }
];

const UserInfoQuestionRolesTab = ({ infoQuestion, setInfoQuestion }) => {
  
  //--------------------------------------------
  // States
  //--------------------------------------------

  const [isCompletionMarker, setIsCompletionMarker] = useState(false);
  const [completionMarkerName, setCompletionMarkerName] = useState("");
  const [savingCompletion, setSavingCompletion] = useState(false);
  const [savedCompletion, setSavedCompletion] = useState(true);
  
  const [isCheckPointMarker, setIsCheckPointMarker] = useState(false);
  const [checkPointMarkerName, setCheckPointMarkerName] = useState("");
  const [savingCheckpoint, setSavingCheckpoint] = useState(false);
  const [savedCheckpoint, setSavedCheckpoint] = useState(true);

  useEffect(()=>{
    setIsCompletionMarker(infoQuestion?.completionMarker?.hasRole);
    setCompletionMarkerName(infoQuestion?.completionMarker?.displayName);
    setIsCheckPointMarker(infoQuestion?.checkpointMarker?.hasRole);
    setCheckPointMarkerName(infoQuestion?.checkpointMarker?.displayName);
  },[infoQuestion])


  const saveCompletionMarker = async (newState, newName) => {
    const trimmedName = newName.trim();
    setSavingCompletion(true);
    setSavedCompletion(false);

    try {
      await axiosInstance.patch(`/knovia/myInfo/userInfoQuestion/${infoQuestion._id}/updateRoleField`, {
        field: "completionMarker",
        hasRole: newState,
        displayName: newState ? trimmedName : ""
      });

      setInfoQuestion(prev => ({
        ...prev,
        completionMarker: {
          hasRole: newState,
          displayName: newState ? trimmedName : ""
        }
      }));
      setCompletionMarkerName(prev => trimmedName);
      setSavedCompletion(true);
    } catch (err) {
      console.error("Save failed (completionMarker):", err);
    } finally {
      setSavingCompletion(false);
    }
  };


  const saveCheckpointMarker = async (newState, newName) => {
    const trimmedName = checkPointMarkerName.trim();
    setSavingCheckpoint(true);
    setSavedCheckpoint(false);

    try {
      await axiosInstance.patch(`/knovia/myInfo/userInfoQuestion/${infoQuestion._id}/updateRoleField`, {
        field: "checkpointMarker",
        hasRole: newState,
        displayName: newState ? trimmedName : ""
      });

      setInfoQuestion(prev => ({
        ...prev,
        checkpointMarker: {
          hasRole: newState,
          displayName: newState ? trimmedName : ""
        }
      }));
      setCheckPointMarkerName(prev => trimmedName);
      setSavedCheckpoint(true);
    } catch (err) {
      console.error("Save failed (checkpointMarker):", err);
    } finally {
      setSavingCheckpoint(false);
    }
  };

  return (
    <div>
      {/* Completion Marker */}
      <Row className="mb-4">
        <Col xs={12}>
          <h5>是其中一個答題目標？</h5>
          <Col className="mb-2">
            {savingCompletion && <span style={{ color: "#f1b34c" }}>Saving...</span>}
            {!savingCompletion && 
              <span style={{ color: savedCompletion ? "#34c38f" : "#aeabab" }}>✔ Saved!</span>
            }
          </Col>
          <Row className="align-items-center mb-2">
            <Col xs={12} md={6} xl={2} className="mb-1">
              <Select
                value={booleanOptions.find(opt => opt.value === isCompletionMarker)}
                onChange={({ value }) => {
                  setIsCompletionMarker(prev => value);
                  if (!value) {
                    setCompletionMarkerName("");
                    saveCompletionMarker(false, "");
                  } else {
                    setSavedCompletion(false);
                  }
                }}
                options={booleanOptions}
                isSearchable={false}
              />
            </Col>

            {isCompletionMarker && (
              <>
                <Col xs={10} md={4} xl={3} className="d-flex align-items-center">
                  <p className="mb-0" style={{ minWidth: "100px", whiteSpace: "nowrap" }}>
                    目標名稱
                  </p>
                  <Input
                    placeholder="輸入名稱"
                    value={completionMarkerName}
                    onChange={(e) => setCompletionMarkerName(e.target.value)}
                  />
                </Col>
                <Col xs={2} md={2} xl={3}>
                  <Button
                    color="outline-success"
                    style={{ padding: "7px 8px" }}
                    onClick={() => {saveCompletionMarker(true, completionMarkerName)}}
                    disabled={!completionMarkerName.trim() || savingCompletion}
                  >
                    <i className="bx bx-check"/>
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>

      {/* Checkpoint Marker */}
      <Row className="mb-4">
        <Col xs={12}>
          <h5>是檢查點？</h5>
          <Col className="mb-2">
            {savingCheckpoint && <span style={{ color: "#f1b34c" }}>Saving...</span>}
            {!savingCheckpoint && 
              <span style={{ color: savedCheckpoint ? "#34c38f" : "#aeabab" }}>✔ Saved!</span>
            }
          </Col>
          <Row className="align-items-center mb-2">
            <Col xs={12} md={6} xl={2} className="mb-1">
              <Select
                value={booleanOptions.find(opt => opt.value === isCheckPointMarker)}
                onChange={({ value }) => {
                  setIsCheckPointMarker(value);
                  if (!value) {
                    setCheckPointMarkerName("");
                    saveCheckpointMarker(false, "");
                  } else {
                    setSavedCheckpoint(false);
                  }
                }}
                options={booleanOptions}
                isSearchable={false}
              />
            </Col>

            {isCheckPointMarker && (
              <>
                <Col xs={10} md={4} xl={3} className="d-flex align-items-center">
                  <p className="mb-0" style={{ minWidth: "100px", whiteSpace: "nowrap" }}>
                    檢查點名稱
                  </p>
                  <Input
                    placeholder="輸入名稱"
                    value={checkPointMarkerName}
                    onChange={(e) => setCheckPointMarkerName(e.target.value)}
                  />
                </Col>
                <Col xs={2} md={2} xl={3}>
                  <Button
                    color="outline-success"
                    style={{ padding: "7px 8px" }}
                    onClick={() => {saveCheckpointMarker(true, checkPointMarkerName)}}
                    disabled={!checkPointMarkerName.trim() || savingCheckpoint}
                  >
                    <i className="bx bx-check"/>
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default UserInfoQuestionRolesTab;
